import { render, staticRenderFns } from "./HarborDelete.vue?vue&type=template&id=baf5040e&"
import script from "./HarborDelete.vue?vue&type=script&lang=js&"
export * from "./HarborDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports